import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlignRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6 7H18",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 10.3333H18",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 13.6667H18",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 17H18",
			stroke: "black",
			strokeLinecap: "round"
		})
	]
});
export default SvgAlignRight;
